module.exports = __webpack_public_path__ + "img/Теносиновит шиловидного отростка лучевой кости (болезнь де Кервена).443db4be.png";